import { useQuery } from '@tanstack/react-query';
import { getGoogleLocations } from '../utils/apis';

export const useGoogleLocations = (
  query: string,
  lat?: string,
  lng?: string
) => {
  return useQuery({
    queryKey: ['googleLocations', query, lat, lng], // Include parameters in queryKey for caching
    queryFn: () => getGoogleLocations({ query, lat, lng }), // Pass parameters correctly
    staleTime: 1000 * 60 * 1,
    retry: 2,
    enabled: !!query, // Prevents execution if query is empty
  });
};
